export const colorPalettes = ['neutral', 'main', 'accent', 'support-1', 'info', 'success', 'attention', 'warning', 'danger'] as const;
export type SDS_COLOR_PALETTES = (typeof colorPalettes)[number];
export type SDS_HEADING_LEVELS = 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export type SDS_SIZES = 'xl' | 'lg' | 'md' | 'sm' | 'xs';
export type SDS_VARIANTS = 'primary' | 'secondary' | 'tertiary';
export type AutocompleteTypes =
	| 'off'
	| 'on'
	| 'name'
	| 'honorific-prefix'
	| 'given-name'
	| 'additional-name'
	| 'family-name'
	| 'honorific-suffix'
	| 'nickname'
	| 'email'
	| 'username'
	| 'new-password'
	| 'current-password'
	| 'one-time-code'
	| 'organization-title'
	| 'organization'
	| 'street-address'
	| 'address-line1'
	| 'address-line2'
	| 'address-line3'
	| 'address-level4'
	| 'address-level3'
	| 'address-level2'
	| 'address-level1'
	| 'country'
	| 'country-name'
	| 'postal-code'
	| 'cc-name'
	| 'cc-given-name'
	| 'cc-additional-name'
	| 'cc-family-name'
	| 'cc-number'
	| 'cc-exp'
	| 'cc-exp-month'
	| 'cc-exp-year'
	| 'cc-csc'
	| 'cc-type'
	| 'transaction-currency'
	| 'transaction-amount'
	| 'language'
	| 'bday'
	| 'bday-day'
	| 'bday-month'
	| 'bday-year'
	| 'sex'
	| 'tel'
	| 'tel-country-code'
	| 'tel-national'
	| 'tel-area-code'
	| 'tel-local'
	| 'tel-extension'
	| 'impp'
	| 'url'
	| 'photo';

export type SheriffEvent = CustomEvent<null>;
